<template>
  <el-dialog
    :visible.sync="showDialog"
    append-to-body
    class="dialog-feedbacklist"
    title=""
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
    :show-close="false"
  >
    <template slot="title">
      <div>查看反馈</div>
      <img
        class="icon-delete"
        src="@/assets/icon_dialog_delete.png"
        @click="handleCloseDialog"
      />
    </template>
    <div class="dialog-container">
      <div class="feedback-box">
        <div v-for="(item, idx) in dataList" :key="idx" class="item-feedback">
          <div class="time-box">{{ item.time_insert }}</div>
          <div class="item-content">
            <div class="platform">平台反馈</div>
            <div class="item-content-main">{{ item.mid_table_remark_001 }}</div>
          </div>
        </div>
      </div>
      <el-button
        class="custom-button btn-ff3333 btn-tobind"
        @click="handleIknow"
        >知道了</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { phoneValidator } from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import imgCodeApi from "@/api/imgcode";
import accountApi from "@/api/account";
import sendpohnecodeMixin from "@/views/mixins/sendphonecode";

export default {
  name: "FeedbackList",
  mixins: [sendpohnecodeMixin],
  components: {},
  data() {
    return {
      showDialog: false,
      dataList: [],
      formData: {
        content: "",
      },
      //发送验证码操作
      sendphoneValideForName: "modifyForm",
      sendPhoneFormeDataName: "formData",
      valideFieldPhoneItemName: "user_phone",
      //发送验证码结束------------------------
      imgCodeUrl: "",
      rules: {
        user_phone: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        msg_content: [
          { required: true, message: "填写手机验证码", trigger: "blur" },
        ],
        pic_code: [{ required: true, message: "填写验证码", trigger: "blur" }],
        password_user: [
          { required: true, message: "填写密码", trigger: "blur" },
        ],
      },
      isRequesting: false,
    };
  },
  mounted() {},
  methods: {
    handleIknow: function () {
      let _this = this;
      _this.showDialog=false;
    },

    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    bindCallbck: function () {
      let _this = this;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-feedbacklist {
  /deep/.el-dialog {
    position: absolute;
    width: 540px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 540px;
      padding: 0;
      padding-left: 40px;
      padding-top: 30px;
      padding-right: 40px;
      padding-bottom: 40px;
      box-sizing: border-box;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      justify-content: space-between;
      .icon-delete {
        position: relative;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      //height: 583px;
      padding: 0;
      // padding-bottom: 67px;
      margin-bottom: 67px;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      .dialog-container {
        position: relative;
        width: 100%;
        text-align: center;

        .feedback-box {
          position: relative;
          width: 100%;
          padding-left: 40px;
        padding-right: 40px;
        box-sizing: border-box;
          .item-feedback {
            position: relative;
            width: 100%;
            margin-bottom: 20px;
            &:first-child{
              margin-bottom: 32px;
            }
            &:last-child{
              margin-bottom: 0;
            }
            .time-box {
              position: relative;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #999999;
              line-height: 14px;
              text-align: left;
              margin-bottom: 16px;
            }
            .item-content {
              position: relative;
              width: 100%;
              background: #f4f4f4;
              border-radius: 4px;
              padding: 24px 18px;
              box-sizing: border-box;
              .platform {
                position: relative;
                width: 100%;
                text-align: left;

                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: normal;
                color: #0072ff;
                line-height: 16px;
                margin-bottom: 12px;
              }
              .item-content-main {
                position: relative;
                width: 100%;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: normal;
                color: #222222;
                line-height: 24px;
                text-align: left;

              }
            }
          }
        }

        .btn-tobind {
          width: 160px;
          height: 46px;
          line-height: 46px;
          text-align: center;

          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          margin: 63px auto 0;
        }
      }
    }
  }
}
</style>
